define('models/GoogleAutocompleteCollection',['underscore','jquery','backbone','app','router','ObjectCollection','LocalStorage','models/GoogleAutocompleteModel','prototypes/onQuotaExceededError','string'],
    function (_,$,Backbone,app,router,ObjectCollection,LocalStorage,GoogleAutocompleteModel,onQuotaExceededError,S) {
    //
    // Collection Store
    //

    var autocompleteService;
    var LatLng;

    try{
        LatLng = google.maps.LatLng;
    }catch(err){
        // TODO
    }
    
    

    var GoogleAutocompleteCollectionPrototype = {
        
        name:'GoogleAutocompleteCollection',
        route:'googlePlacesAPIAutocomplete',
        translated:'false',
        model:GoogleAutocompleteModel,
        
        //comparator:function(r){return r.ignored()?1:-1},
        
        initialize:function(){
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this,null);
            //
            //
            this.on('QuotaExceededError',onQuotaExceededError);
        },
        request:function(options){
            //
            var self = this;
            self.options = options;
            if(self.localFetch()){
                return;
            }
            //
            self.fetch();

        },
        getLocalStorageKey:function(){
            var key = this.name;
                key += '_'+this.getQuery();
            return key;
        },
        getQuery:function(){
            var o = _.extend({},this.options);
            delete o.location;
            return $.param(o);
        },
        remoteFetch:function(){
            if(this.options.useGeoloc){
                this.options.location = new LatLng(this.options.lat,this.options.lng);
            }
            var options = _({}).extend(this.options);
            //
            try {
                if (!autocompleteService) {
                    autocompleteService = new google.maps.places.AutocompleteService();
                }
            }catch(err){
                // si Google maps est bloqué, par exemple
                return;
            }

            autocompleteService.getPlacePredictions(options,$.proxy(this.onSync,this));
            GoogleAutocompleteCollection.autocompleteQueryCount ++;
        },
        onSync:function(results,status){
            var collection = this;
            if(status === 'OK'){
                //
                // le clean sert à ignorer les données inutiles
                // afin de ne pas surcharger LocalStorage de données inutiles
                //
                var cleanedResults = _(results).map(function(result){
                    var cleaned = _(result).pick(
                        'description',
                        'place_id',
                        'structured_formatting',
                        'types'
                    );
                    cleaned.usePlaceFetch = collection.options.usePlaceFetch;
                    return cleaned;
                });
                collection.set(cleanedResults);
            }
            collection.setLocalStorageItem();
            collection.trigger('sync',collection);
        },
        url:function(){
            // TODO : gestion de la langue en code langue
           return router.getRouteUrl(this.route,true)({params:this.getQuery()});
        }
        
    };

    var GoogleAutocompleteCollection = ObjectCollection
        .extend(LocalStorage)
        .extend(GoogleAutocompleteCollectionPrototype);


    return GoogleAutocompleteCollection;
});
